import axios from 'axios';

let url = "https://api.makeyourtest.appandwebstudio.com.br";

if (window.location.hostname === 'localhost') {
  url = 'http://localhost:8000';
}

export default axios.create({
  baseURL: url
});